<template>
  <v-dialog
    v-model="internalDialog"
    :fullscreen="isMobile"
    :hide-overlay="isMobile"
    max-width="730"
  >
    <v-card class="pa-5">
      <!-- header -->
      <v-container class="pa-0 d-flex justify-space-between mb-5">
        <v-card-text class="text-body-1 ma-0 pa-0">
          {{ $t("details") }} {{ $t("salery") }}
        </v-card-text>

        <v-icon @click="close()">mdi-close</v-icon>
      </v-container>
      <!-- loading -->
      <div v-if="loading" class="loading-box">
        <v-progress-circular indeterminate size="36" width="3" color="primary" />
      </div>
      <!-- list -->
      <div v-else class="dialog-body">
        <v-card-text v-if="benefits.length" class="pa-0 ma-0 text-body-1 section-title">{{
          $t("benefit")
        }}</v-card-text>
        <v-card-text
          v-for="(item, index) in benefits"
          :key="'benefit-' + index"
          class="pa-0 py-3 ma-0 text-body-2 salary-row"
        >
          <span class="label">{{ item.name || item.salary.name }} :</span>
          <span class="value">
            {{ formatMoney(item.value) }} {{ $store.state.currency.name }}
          </span>
        </v-card-text>
        <v-card-text
          v-if="deductions.length"
          class="pa-0 ma-0 mt-4 text-body-1 section-title"
          >{{ $t("deductions") }}</v-card-text
        >
        <v-card-text
          v-for="(item, index) in deductions"
          :key="'deduction-' + index"
          class="pa-0 py-3 ma-0 text-body-2 salary-row"
        >
          <span class="label">{{ item.name || item.salary.name }} :</span>
          <span class="value">
            {{ formatMoney(item.value) }} {{ $store.state.currency.name }}
          </span>
        </v-card-text>
        <div v-if="totalBenefits > 0" class="totals mt-6">
          <div class="salary-row total-row">
            <span class="label">{{ $t("sum") }}</span>
            <span class="value">
              {{ formatMoney(totalBenefits) }} {{ $store.state.currency.name }}
            </span>
          </div>

          <div v-if="totalDeductions > 0" class="salary-row total-row">
            <span class="label">{{ $t("sum") }} {{ $t("deductions") }}</span>
            <span class="value">
              {{ formatMoney(totalDeductions) }} {{ $store.state.currency.name }}
            </span>
          </div>

          <div v-if="pureTotal > 0" class="salary-row total-row final-total">
            <span class="label">{{ $t("total_net_pay") }}</span>
            <span class="value">
              {{ formatMoney(pureTotal) }} {{ $store.state.currency.name }}
            </span>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    calc: Boolean,
    afterSave: Boolean,
    rowData: {
      type: [Object, Array],
      default: () => [],
    },
    year: {
      type: [String, Number],
      default: null,
    },
    month: {
      type: [String, Number],
      default: null,
    },
  },

  data() {
    return {
      internalDialog: false,
      loading: false,
      benefits: [],
      deductions: [],
      obj: [],
      taxObj: [],
      salaryObject: null,
    };
  },

  watch: {
    calc(val) {
      this.internalDialog = val;

      if (val && this.rowData) {
        if (!this.afterSave) {
          this.getDetails();
        }
        if (this.afterSave) {
          this.getDetailsAfterSave();
        }
      }
    },

    internalDialog(val) {
      if (!val) {
        this.$emit("close");
      }
    },
  },
  computed: {
    totalBenefits() {
      return this.benefits.reduce((sum, item) => sum + Number(item.value || 0), 0);
    },

    totalDeductions() {
      return this.deductions.reduce((sum, item) => sum + Number(item.value || 0), 0);
    },

    // totalTax() {
    //   if (this.salaryObject) {
    //     return Number(this.salaryObject.tax || 0);
    //   }
    //   return this.obj.reduce((sum, item) => sum + Number(item.tax || 0), 0);
    // },
    totalEmployeeInsurance() {
      if (this.salaryObject) {
        return Number(this.salaryObject.employee_insurance || 0);
      }
      return this.obj.reduce((sum, item) => sum + Number(item.employeeInsurance || 0), 0);
    },

    pureTotal() {
      return (
        this.totalBenefits -
        this.taxObj -
        this.totalEmployeeInsurance -
        this.totalDeductions
      );
    },
  },
  methods: {
    async getDetails() {
      var app = this;
      app.loading = true;
      let config = this.rowData;
      let isYear = this.year ? this.year : null;
      let isMonth = this.month ? this.month : null;
      app.$axios
        .post(app.$endpoint + "salary/calc-salary", {
          configs: config,
          year: isYear,
          month: isMonth,
        })
        .then((response) => {
          const data = response?.data.items || [];
          this.obj = response?.data.items || [];
          this.taxObj = response?.data.tax.total_tax_amount || [];
          this.benefits = data.filter((i) => i.type === "benefit");
          this.deductions = data.filter((i) => i.type === "deductions");
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
        });
    },
    async getDetailsAfterSave() {
      var app = this;
      app.loading = true;
      let config = app.rowData;
      const id_ = app.rowData.id ? app.rowData.id : 0;
      app.$axios
        .get(app.$endpoint + "salary/employee-salary/" + id_)
        .then((response) => {
          const data = response?.data?.items || [];
          this.salaryObject = response?.data?.salary || null;
          app.benefits = data.filter((i) => i.salary?.level === "benefit");
          app.deductions = data.filter((i) => i.salary?.level === "deductions");
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
        });
    },
    formatMoney(val) {
      return new Intl.NumberFormat("fa-IR").format(val || 0);
    },
    close() {
      this.internalDialog = false;
    },
  },
};
</script>
<style scope>
.loading-box {
  min-height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-body {
  max-height: 400px;
  overflow-y: auto;
  padding: 0 15px;
}
.section-title {
  font-weight: bold;
  margin-bottom: 15px;
}
.salary-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
}
.label {
  color: #444;
}
.value {
  color: #222;
}
.totals {
  margin-top: 20px;
  padding-top: 10px;
}
.total-row {
  font-weight: 600;
}
.final-total {
  font-size: 16px;
}
.dialog-body::-webkit-scrollbar {
  width: 3px;
}

.dialog-body::-webkit-scrollbar-track {
  background: transparent;
}

.dialog-body::-webkit-scrollbar-thumb {
  background: #b5b5b5;
  border-radius: 10px;
}

.dialog-body::-webkit-scrollbar-thumb:hover {
  background: #8f8f8f;
}
</style>
